import React, { ReactElement } from "react";

import clsx from "clsx";

export default function SubHeaderTitle({ children }: React.PropsWithChildren) {
  return (
    <div
      className={clsx(
        "flex w-full pr-4 items-center justify-start h-10 text-sm font-bold"
      )}
    >
      {children}
    </div>
  );
}
